import { URLS } from "../utils/routes";
import { SocialCoachSession, UserRole } from "@/services/bedrock";

const editorVideoProjectLegacyRedirects: Record<string, string> = {
  "/editor/queueList": URLS.editor.videoProjects.grid,
  "/editor/queueList/": URLS.editor.videoProjects.grid,
  "/editor/videoproject/:id": URLS.editor.videoProjects.detail,
};

const legacyRedirectMappings: Record<UserRole, Record<string, string>> = {
  COACH: {
    "/video-scripts": URLS.coach.videoScripts,
    "/video-script": URLS.coach.newVideoScript,
    "/video-script/:id": URLS.coach.videoScript,
    "/scripts/:id": URLS.coach.videoScript,
    "/videocatalyst": URLS.coach.videoProjects,
    "/videoproject/new": URLS.coach.newVideoProject,
    "/videoproject/detail/:id": URLS.coach.videoProject,
    "/api_management": URLS.coach.apiKeys,
    "/sign-up-profile": URLS.coach.companyInfo,
    "/settings/app-settings": URLS.coach.platformSettings,
    "/settings/digest": URLS.coach.digestEmails,
    "/player_cards": URLS.coach.playerCards,
    "/prompt/:promptId": URLS.coach.prompt,
    "/new-prompt": URLS.coach.newPrompt,
    "/coach-players": URLS.coach.players,
    "/coach-players/:playerId": URLS.coach.editPlayer,
    "/coach-players/new": URLS.coach.newPlayer,
    "/assistants": URLS.coach.assistants,
    "/assistants/:userId": URLS.coach.editAssistant,
    "/assistants/new": URLS.coach.newAssistant,
    "/video-page/new": URLS.coach.videoPages + "?new=true",
  },
  PLAYER: {
    "/scripts/:id": URLS.player.videoScript,
    "/player/player_cards": URLS.player.playerCards,
    "/player/library/video-script": URLS.player.newVideoScript,
    "/player/video-script/:id": URLS.player.videoScript,
    "/player/library/video-catalyst": URLS.player.videoProjects,
    "/player/videoproject/new": URLS.player.newVideoProject,
    "/videoproject/detail/:id": URLS.player.videoProject,
    "/player/library/video-catalyst/:id": URLS.player.videoProject,
    "/video-page/new": URLS.player.videoPages + "?new=true",
  },
  ADMIN: {
    ...editorVideoProjectLegacyRedirects,
    "/editor/queueList/board": URLS.editor.videoProjects.board,
  },
  EDITOR: {
    ...editorVideoProjectLegacyRedirects,
    "/editor/queueList/board": URLS.editor.videoProjects.grid,
  },
  ASSISTANT_COACH: {},
};

export type LegacyRedirectRule = {
  path: string;
  getTo: (session: SocialCoachSession | undefined, params: Record<string, string>) => string;
};

// Without a session (logged out, or still loading) every legacy path is registered so the route can send
// the user to sign-in with a returnTo; the role-specific redirect then resolves once they're logged in.
const allLegacyPaths = [...new Set(Object.values(legacyRedirectMappings).flatMap(Object.keys))];

export const getLegacyRedirectRules = (session?: SocialCoachSession): LegacyRedirectRule[] => {
  if (!session) return allLegacyPaths.map(path => ({ path, getTo: () => URLS.login }));

  const effectiveRole = session.userRole == "ASSISTANT_COACH" ? "COACH" : session.userRole;
  return Object.entries(legacyRedirectMappings[effectiveRole]).map(([path, redirect]) => {
    return {
      path,
      getTo: (session, params) => {
        if (!session) return URLS.login;
        const effectiveRedirect = Object.entries(params).reduce((acc, [key, value]) => {
          return acc.replace(`:${key}`, value);
        }, redirect);
        return effectiveRedirect;
      },
    };
  });
};
